import { render } from "./PartnerPaypal.vue?vue&type=template&id=2652e048"
import script from "./PartnerPaypal.vue?vue&type=script&lang=js"
export * from "./PartnerPaypal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__